import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Members from "./pages/Members/Members";

import AuthProvider from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import AddMember from "./pages/Members/AddMember";
import EditMember from "./pages/Members/EditMember";
import Memberships from "./pages/Memberships/Memberships";
import AddMembership from "./pages/Memberships/AddMembership";
import Payments from "./pages/Payments/Payments";
import AddPayment from "./pages/Payments/AddPayment";
import Attendance from "./pages/Attendance/Attendance";
import AddAttendance from "./pages/Attendance/AddAttendance";
import Register from "./pages/Register/Register";
import Trainers from "./pages/Trainers/Trainers";
import AddTrainer from "./pages/Trainers/AddTrainer";
import AssignTrainer from "./pages/Trainers/AssignTrainer";
import Reports from "./pages/Reports/Reports";
import Settings from "./pages/Settings/Settings";
import QRScanner from "./pages/Attendance/QRScanner";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import PendingApproval from "./pages/PendingApproval/PendingApproval";
import SubscriptionExpired from "./pages/SubscriptionExpired/SubscriptionExpired";
import ManageGyms from "./pages/Admin/ManageGyms";
import Revenue from "./pages/Admin/Revenue";
import ExpiryMonitor from "./pages/Admin/ExpiryMonitor";
import Subscriptions from "./pages/Admin/Subscriptions";
import AddPlan from "./pages/Admin/AddPlan";
import Subscription from "./pages/Subscription/Subscription";
import RenewalNotifications from "./pages/Renewals/RenewalNotifications";
import AboutSoftware from "./pages/AboutSoftware/AboutSoftware";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import LandingPage from "./pages/LandingPage/LandingPage";
import AdminLeads from "./pages/AdminLeads/AdminLeads";
import InvoiceHistory from "./pages/InvoiceHistory/InvoiceHistory";
// import FeatureRoute from "./components/FeatureRoute";
import AccessDenied from "./pages/AccessDenied/AccessDenied";
import AccessDeniedAdmin from "./pages/AccessDeniedAdmin/AccessDeniedAdmin";
import WorkoutPlans from "./pages/WorkoutPlans/WorkoutPlans";
import AddWorkoutPlan from "./pages/WorkoutPlans/AddWorkoutPlan";
import EditWorkoutPlan from "./pages/WorkoutPlans/EditWorkoutPlan";
import AddDietPlan from "./pages/DietPlans/AddDietPlan";
import DietPlans from "./pages/DietPlans/DietPlans";
import EditDietPlan from "./pages/DietPlans/EditDietPlan";
import MemberPortal from "./pages/MemberPortal/MemberPortal";
import AdminRoute from "./routes/AdminRoute";
// import GymProvider from "./context/GymContext";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route path="/pending-approval" element={<PendingApproval />} />
          <Route
            path="/admin/leads"
            element={
              <AdminRoute>
                <AdminLeads />
              </AdminRoute>
            }
          />
          <Route path="/member/:token" element={<MemberPortal />} />

          <Route
            path="/subscription-expired"
            element={
              <ProtectedRoute>
                <SubscriptionExpired />
              </ProtectedRoute>
            }
          />
          {/* <Route path="*" element={<NotFound />} /> */}

          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <Members />
              </ProtectedRoute>
            }
          />
          <Route
            path="/members/add"
            element={
              <ProtectedRoute>
                <AddMember />
              </ProtectedRoute>
            }
          />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/access-denied-admin" element={<AccessDeniedAdmin />} />
          <Route
            path="/members/edit/:id"
            element={
              <ProtectedRoute>
                <EditMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memberships"
            element={
              <ProtectedRoute>
                <Memberships />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workout-plans"
            element={
              <ProtectedRoute>
                <WorkoutPlans />
              </ProtectedRoute>
            }
          />

          <Route
            path="/workout-plans/edit/:id"
            element={
              <ProtectedRoute>
                <EditWorkoutPlan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diet-plans/add"
            element={
              <ProtectedRoute>
                <AddDietPlan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diet-plans"
            element={
              <ProtectedRoute>
                <DietPlans />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diet-plans/add"
            element={
              <ProtectedRoute>
                <AddDietPlan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diet-plans/edit/:id"
            element={
              <ProtectedRoute>
                <EditDietPlan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/workout-plans/add"
            element={
              <ProtectedRoute>
                <AddWorkoutPlan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <InvoiceHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/memberships/add"
            element={
              <ProtectedRoute>
                <AddMembership />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <Payments />
              </ProtectedRoute>
            }
          />

          <Route
            path="/payments/add"
            element={
              <ProtectedRoute>
                <AddPayment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <ProtectedRoute>
                <Attendance />
              </ProtectedRoute>
            }
          />

          <Route
            path="/attendance/add"
            element={
              <ProtectedRoute>
                <AddAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trainers"
            element={
              <ProtectedRoute>
                <Trainers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/trainers/add"
            element={
              <ProtectedRoute>
                <AddTrainer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AssignTrainer"
            element={
              <ProtectedRoute>
                <AssignTrainer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/about-software" element={<AboutSoftware />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route
            path="/admin/subscriptions/add"
            element={
              <AdminRoute>
                <AddPlan />
              </AdminRoute>
            }
          />
          <Route
            path="/renewals"
            element={
              <ProtectedRoute>
                <RenewalNotifications />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/admin/subscriptions/add"
            element={
              <AdminRoute>
                <AddPlan />
              </AdminRoute>
            }
          /> */}
          <Route
            path="/admin/subscriptions"
            element={
              <AdminRoute>
                <Subscriptions />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/expiry"
            element={
              <AdminRoute>
                <ExpiryMonitor />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/revenue"
            element={
              <AdminRoute>
                <Revenue />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/gyms"
            element={
              <AdminRoute>
                <ManageGyms />
              </AdminRoute>
            }
          />

          <Route
            path="/qr-scanner"
            element={
              <ProtectedRoute>
                <QRScanner />
              </ProtectedRoute>
            }
          />

          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
